import React, { Component, useEffect, useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";

import styles from "./styles";

function CardVaga({ vaga, mostrarConfirm, irParaDetalhes }) {
  return (
    <View style={styles.cardVaga}>
      <Text
        style={[
          {
            textAlign: "left",
            marginBottom: 2,
            fontSize: 18,
            fontWeight: "bold",
            color: "#F1F1F1",
          },
        ]}
      >
        {vaga.empresa?.toUpperCase()}
      </Text>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <Text style={{ fontWeight: "bold", color: "#C1C1C1" }}>
          {vaga.tipo_vaga}
          {" - "}
        </Text>
        <Text style={{ color: "#C1C1C1", flexWrap: "wrap", flexShrink: 1 }}>
          {vaga.cargo}
        </Text>
      </View>

      <Text style={{ fontWeight: "bold", color: "#C1C1C1" }}>Local</Text>
      <Text style={{ color: "#C1C1C1" }}>{vaga.local_trabalho}</Text>

      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-evenly",
          marginTop: 5,
        }}
      >
        <TouchableOpacity
          style={{ alignItems: "center", padding: 5 }}
          onPress={irParaDetalhes}
        >
          <Text style={{ color: "green", fontSize: 16 }}>Ver mais</Text>
        </TouchableOpacity>
        {vaga.status === 1 && (
          <TouchableOpacity
            style={{ alignItems: "center", padding: 5 }}
            onPress={() => mostrarConfirm(vaga.id)}
          >
            <Text style={{ color: "#04F", fontSize: 16 }}>Candidatar-se</Text>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
}

export default CardVaga;
